import React, { Suspense, useState } from "react";

const ChatWidget = React.lazy(() => {
  const enabled =
    String(
      process.env.REACT_APP_ENABLE_CHATBOT_REMOTE || "true",
    ).toLowerCase() === "true";
  if (process.env.NODE_ENV === "test" || !enabled) {
    return Promise.resolve({ default: () => null });
  }
  return import("baseProject/ChatWidget")
    .then((module) => ({ default: module.default || module }))
    .catch((error) => {
      console.error("Failed to load baseProject/ChatWidget", error);
      return { default: () => null };
    });
});

const LoadingSpinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      fontSize: "16px",
      color: "#6c757d",
    }}
  ></div>
);

const FederatedModule = () => {
  const [showChat, setShowChat] = useState(false);
  const apiKey = process.env.REACT_APP_CHATBOT_API_KEY || "";
  const botId = process.env.REACT_APP_CHATBOT_BOT_ID || "";

  React.useEffect(() => {
    window.WIDGET_CONFIG = {
      apiKey,
    };
  }, [apiKey]);

  const [config] = useState({
    botId,
    theme: {
      colors: {
        primary: "#F97316",
        primaryText: "#ffffff",
        secondary: "#06B6D4",
        secondaryBg: "",
        background: "#FFFFFF",
        surface: "#ffffff",
        text: "#1F2937",
        textSecondary: "#6B7280",
        border: "",
        error: "#DC2626",
        success: "#16A34A",
        warning: "#FBBF24",
      },
      spacing: {
        xs: "4px",
        sm: "8px",
        md: "14px",
        lg: "20px",
        xl: "26px",
      },
      typography: {
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Inter", "Helvetica Neue", Arial, sans-serif',
        fontSize: "0.8rem",
        fontWeight: "400",
        lineHeight: "1.5",
      },
      borderRadius: {
        sm: "6px",
        md: "11px",
        lg: "16px",
        full: "9999px",
      },
      shadows: {
        sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
        xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      },
    },
    header: {
      title: "Atlas Assistant",
      onClose: () => setShowChat(false),
    },
    container: {
      onToggleMinimize: () => setShowChat((prev) => !prev),
    },
    position: "bottom-right",
  });

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ChatWidget initialConfig={config} isOpen={showChat} />
    </Suspense>
  );
};

export default FederatedModule;
